export { default } from 'pages/loyalty/loyalty-claim-points/loyalty-claim-points-accepted';
